import React from "react";
import { LegalPageEditor } from "@/components/pages/legal-pages/LegalPageEditor";
import { LegalPageView } from "@/components/pages/legal-pages/LegalPageView";

interface PrivacyPolicyPageProps {
  mode?: "edit" | "view";
}

export const PrivacyPolicyPage = ({
  mode = "edit",
}: PrivacyPolicyPageProps): React.JSX.Element => {
  if (mode === "view") {
    return (
      <LegalPageView
        type="privacy-policy"
        titleKey="layout.superAdminNav.items.settings.privacy_policy"
      />
    );
  }

  return <LegalPageEditor type="privacy-policy" />;
};
